import React from "react";
import {
  ExclamationIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  XIcon,
} from "@heroicons/react/outline";

const CapitalChangeWarning = ({
  parent,
  children,
  sharesDifference,
  votingDifference,
  isIncrease,
  isDecrease,
  currentChildrenTotal,
  targetTotal,
  onClose,
}) => {
  const parentName =
    parent.names?.companyName ||
    `${parent.names?.firstName || ""} ${parent.names?.lastName || ""}`.trim() ||
    "Corporate shareholder";

  const difference = Math.abs(sharesDifference);

  return (
    <div
      className={`border-l-4 p-4 relative ${
        isIncrease
          ? "bg-blue-50 border-blue-400"
          : "bg-orange-50 border-orange-400"
      }`}
    >
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 focus:outline-none"
        >
          <XIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      )}
      <div className="flex pr-6">
        <div className="flex-shrink-0">
          {isIncrease ? (
            <ArrowUpIcon className="h-5 w-5 text-blue-400" aria-hidden="true" />
          ) : (
            <ArrowDownIcon
              className="h-5 w-5 text-orange-400"
              aria-hidden="true"
            />
          )}
        </div>
        <div className="ml-3 flex-1">
          <h3
            className={`text-sm font-medium ${
              isIncrease ? "text-blue-800" : "text-orange-800"
            }`}
          >
            {isIncrease
              ? "Capital Increase Detected"
              : "Capital Decrease Detected"}
          </h3>
          <div
            className={`mt-2 text-sm ${
              isIncrease ? "text-blue-700" : "text-orange-700"
            }`}
          >
            <p>
              <strong>{parentName}</strong> ownership{" "}
              {isIncrease ? (
                <span className="font-semibold text-green-600">increased</span>
              ) : (
                <span className="font-semibold text-red-600">decreased</span>
              )}{" "}
              from <strong>{currentChildrenTotal.toFixed(2)}%</strong> to{" "}
              <strong>{targetTotal.toFixed(2)}%</strong> (
              {isIncrease ? "+" : ""}
              {sharesDifference.toFixed(2)}%).
            </p>
            <p className="mt-1">
              {isIncrease ? (
                <>
                  <strong className="text-blue-800">
                    {difference.toFixed(2)}%
                  </strong>{" "}
                  additional ownership must be allocated to beneficial owners.
                </>
              ) : (
                <>
                  Current beneficial owners hold{" "}
                  <strong className="text-orange-800">
                    {difference.toFixed(2)}%
                  </strong>{" "}
                  more than the new total. Reduce or remove beneficiaries to
                  match.
                </>
              )}
            </p>
            {children.length > 0 && (
              <p className="mt-1 text-xs">
                Affected beneficial owners: {children.length}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapitalChangeWarning;
